import React from 'react';

const Logo = ({ className = "", size = "md" }) => {
  const sizeClasses = {
    sm: "h-10",
    md: "h-16",
    lg: "h-24",
    xl: "h-48"
  };

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/logo.png" 
        alt="BIZREP - Business Representative Agents" 
        className={`${sizeClasses[size]} w-auto`}
      />
    </div>
  );
};

export default Logo;

